import styled from 'styled-components';
import {
  getSpace,
  getTextType,
  mq,
  getTransition,
  gridContainer,
  setGridColumns,
  px2rem,
  getGridColumns,
  getColor
} from '../../../stylesheets/tools';

const StyledCurrentInfo = styled.section`
  .current-info__container {
    position: relative;
    padding: ${getSpace('xxxl')} 0;

    ${mq('l')} {
      ${gridContainer()};
      gap: ${px2rem('120px')} ${px2rem('60px')};
      grid-template-areas:
        'intro fixed'
        'tours fixed';
      ${setGridColumns('1fr', 2)}
    }

    ${mq('xl')} {
      gap: ${px2rem('120px')} ${px2rem('14px')};
      grid-template-areas:
        'intro intro intro intro intro fixed fixed'
        'tours tours tours tours tours fixed fixed';
      ${setGridColumns('1fr', 7)}
    }

    .current-info__more-events {
      margin-top: ${px2rem('10px')};
    }

    .current-info__preview-image {
      display: none;

      ${mq('xl')} {
        max-width: 240px;
        width: 100%;
        margin-top: 30px;
        display: block;

        img {
          width: 100%;
          object-fit: cover;
          aspect-ratio: 4 / 3;
        }
      }
    }

    .current-info__events-list {
      .current-info__event-container {
        position: relative;

        &:not(:last-child):after {
          content: '';
          width: 100%;
          height: ${px2rem('1.5px')};
          display: inline-block;
          background-color: ${getColor('gray')};
          margin: ${px2rem('15px')} 0;
        }

        .current-info__event-content {
          .event__time {
            display: inline-block;
            font-size: ${px2rem('14px')};
            margin-bottom: ${px2rem('5px')};
          }
          h3 {
            font-size: ${px2rem('18px')};
            color: ${props => props.theme.globalTheme.contrastCta};
          }
          .current-info__event-stretched-link {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
          }
        }
      }
    }

    .current-info__opening-hours {
      margin-top: ${px2rem('20px')};

      .current-info__closed {
        text-transform: uppercase;
      }
      .current-info__opened {
        font-weight: bold;
      }
      .current-info__todays-openening {
        padding-left: ${px2rem('8px')};
      }
    }
    .current-info__hours {
      ${getTextType('copy', 'international')}
      display: inline-block;
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;

        &:first-of-type {
          font-weight: bold;
        }

        span:first-of-type {
          padding-right: ${px2rem('10px')};
        }
      }
    }

    .current-info__base-container.intro {
      grid-area: intro;

      .current-info__base-first-col {
        text-align: center;

        ${mq('l')} {
          text-align: left;
        }
      }
    }
    .current-info__base-container.guided-tours {
      grid-area: tours;
    }
    .current-info__base-container {
      ${mq('xl')} {
        ${gridContainer()};
        ${setGridColumns('1fr', 5)};
      }
      .current-info__base-first-col {
        margin-bottom: ${px2rem('40px')};

        ${mq('xl')} {
          margin-bottom: 0;
          ${getGridColumns([1, 2], { m: [1, 3] })}
        }
      }
      .current-info__base-second-col {
        .current-info__info-box {
          display: flex;
          gap: ${px2rem('12px')};
          padding: ${px2rem('15px')} 0;

          ${mq('m')} {
            padding: 0;
          }
          .current-info__info-icon {
            flex: none;

            svg {
              height: ${px2rem('24px')};
              width: ${px2rem('24px')};
            }
          }
          .current-info__info-content {
            margin: 0;
          }
        }
        ${mq('xl')} {
          ${getGridColumns([1, 1], { m: [3, 6] })}
          padding-left: ${px2rem('60px')};
          padding-right: ${px2rem('44px')};
        }
      }
    }

    .current-info__fixed-container {
      grid-area: fixed;
      padding: ${px2rem('20px')} 0 ${px2rem('60px')} 0;

      ${mq('l')} {
        padding: 0 0 0 ${px2rem('20px')};
      }

      ${mq('xl')} {
        padding: 0 0 0 ${px2rem('10px')};
      }

      .current-info__fixed {
        position: relative;
        border: 2px solid #000;
        border-radius: ${px2rem('8px')};
        display: flex;
        flex-direction: column;
        padding: ${px2rem('30px')};
        gap: ${px2rem('15px')};

        ${mq('l')} {
          gap: ${px2rem('25px')};
          position: sticky;
          top: ${px2rem('80px')};
        }

        ${mq('xl')} {
          padding: ${px2rem('30px')};
        }

        .current-info__item {
          display: flex;
          gap: ${px2rem('25px')};

          .current-info__icon {
            flex: none;
          }
          .current-info__item-copy {
            width: 100%;
            padding-top: ${px2rem('8px')};

            p {
              width: 100%;
              margin: 0;
            }
            a {
              ${getTextType('subline')};
              text-transform: uppercase;
              border: 0;
              color: ${props => props.theme.globalTheme.contrastCta};

              &:hover {
                opacity: 0.75;
              }
            }
          }
        }
      }
    }
  }

  /* Accordion Styles */
  .accordion__item {
    &.entering,
    &.entered {
      .accordion__title {
        svg {
          transform: rotateX(180deg);
        }

        &:hover svg {
          transform: translateY(-1px) rotateX(180deg);
        }
      }
    }

    &.entering,
    &.entered,
    &.exiting {
      .accordion__body {
        display: block;
      }
    }

    &.entered {
      .accordion__body {
        max-height: 500px;
        opacity: 1;
      }
    }

    &.exited {
      .accordion__body {
        display: none;
      }
    }
  }

  .accordion__button {
    ${getTextType('copy', 'international')}
    display: inline-flex;
    align-items: center;

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }

    svg {
      margin-left: 10px;
      ${getTransition('defaultFast')}
    }

    &:hover svg {
      transform: translateY(1px);
    }

    &[aria-expanded='true'] svg {
      transform: rotateX(180deg);
    }
  }

  .accordion__body {
    display: none;
    opacity: 0;
    max-height: 0;
    ${getTransition('defaultFast')}
  }

  @media print {
    .accordion__body {
      display: block;
    }
  }
`;

export default StyledCurrentInfo;
